import page from "./page";
import format from "./format";
import error from "./error";
import message from "./message";
import validation from "./validation";
import object from "./object";

export const TRANSLATIONS_TH = {
    format,
    page,
    error,
    message,
    validation,
    object,
};
